module.exports = __webpack_public_path__ + "img/icon-linkedin.ddb088ca.jpg";